
import Vue from 'vue'

import { VTooltip } from 'vuetify/lib'
import { formatDateValue } from '@/util/formatters'
import { trimArray } from '@/util/tableUtilities'
import JcdcExportBtn from '@/components/jcdc/JcdcExportBtn.vue'

export default Vue.extend({
  name: 'JcdcExportWrapper',
  components: { JcdcExportBtn, VTooltip },
  props: {
    // Button
    btnText: { type: String, required: true },
    btnIcon: { type: String, required: true },
    align: {
      type: String,
      default: 'left',
      validator(value: string) {
        return ['left', 'center', 'right'].indexOf(value) !== -1
      },
    },
    secondary: { type: Boolean, default: false },
    iconOnly: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    // File name
    appTitle: { type: String, required: true },
    title: { type: String, required: true },
    tabTitle: { type: String, default: 'Report' },
    searchList: { type: Array as () => string[], default: (): [] => [] },
    filterList: { type: Array as () => string[], default: (): [] => [] },
    infoDate: { type: [String, Date, Number, Object], default: null },
    // Custom btn
    customBtn: { type: Boolean, default: false },
  },
  computed: {
    attachID() {
      return `_${Math.random().toString(36).substr(2, 9)}`
    },
    fileName(): string {
      return `${this.appTitle} - ${this.title}${
        this.tabTitle != 'Report' ? ` - ${this.tabTitle}` : ''
      }${
        this.searchList.length != 0
          ? ` - ${this.trimArray(this.searchList).join('_')}`
          : ''
      }${
        this.filterList.length != 0
          ? ` - ${this.trimArray(this.filterList).join('_')}`
          : ''
      }${this.infoDate ? ` - ${formatDateValue(this.infoDate)}` : ''}`
    },
  },
  methods: {
    trimArray,
    emitClick() {
      this.$emit('click', this.fileName)
    },
  },
})
